import { useScenarioStore } from '@/stores/scenario'
import { storeToRefs } from 'pinia'
import type { ScenarioFormMixinProps, ScenarioFormTab } from '@/components/scenario-form/type/type'
import { computed, ref, watch } from 'vue'

export function useScenarioFormComposable(
  props: ScenarioFormMixinProps,
  emit: (event: 'updateTabCompletion', value: ScenarioFormTab, isCompleted: boolean) => void,
  customIsComplete?: () => boolean
) {
  const scenarioStore = useScenarioStore()
  const { currentItem } = storeToRefs(scenarioStore)

  const isValid = ref<boolean>()
  const formRef = ref()

  const hasHelpText = (field: string) => {
    if (!scenarioStore.fields) return false
    return !!scenarioStore.fields[field]?.help_text
  }

  const isComplete = computed(() => {
    return customIsComplete ? customIsComplete() : true
  })

  watch(isValid, () => {
    emit('updateTabCompletion', props.tab, isComplete.value)
  })

  const isReadOnly = computed(() => {
    return !scenarioStore.canChangeScenario || props.readonly
  })

  return {
    ...props,
    scenarioStore,
    currentItem,
    isValid,
    isReadOnly,
    formRef,
    hasHelpText,
    isComplete
  }
}
